import React, { useContext, useEffect, useState } from "react"
import { DiscadorContext } from "../../../Discador";
import { usePauseTime } from "../../../../hooks/usePauseTime";

export const PauseTime = () => {

  const { contagem, setContagem } = usePauseTime()
  const { onPause } = useContext(DiscadorContext)

  const [time, setTime] = useState(0)
  const [hours, setHours] = useState(~~(time / 3600));
  const [minutes, setMinutes] = useState(~~((time % 3600) / 60));
  const [seconds, setSeconds] = useState(~~time % 60);


  useEffect(() => {
    let interval: NodeJS.Timeout = setInterval(() => { }, 0);
    const iniciarContagem = () => {
      interval = setInterval(() => {
        setTime(time + 1);
      }, 1000);
    };
    if (onPause) {
      iniciarContagem();
    } else {
      clearInterval(interval);
      setContagem('00:00:00');
      setTime(0)
    }
    return () => clearInterval(interval);
  }, [onPause, time])

  useEffect(() => {
    setHours(~~(time / 3600));
    setMinutes(~~((time % 3600) / 60));
    setSeconds(~~time % 60);

    let hora = `${hours < 10 ? '0' : ''}${hours}`;
    let minuto = `${minutes < 10 ? '0' : ''}${minutes}`;
    let segundo = `${seconds < 10 ? '0' : ''}${seconds}`;

    setContagem(`${hora}:${minuto}:${segundo}`);
  }, [time, hours, minutes, seconds]);


  return (
    <>

      {
        onPause && (
          <div className="flex items-center text-primary gap-2 border-error border p-1 rounded-md text-sm">
            <p>Em Pausa: </p>
            <p>{contagem}</p>

          </div>
        )

      }
    </>
  )
}